(function () {
  'use strict';

  angular.module('wsLrs.directives').directive('betaTag', [function () {
    return {
      restrict: 'E',
      scope: true,
      replace: true,
      template: "\n               <span class=\"beta-tag\">beta</span> \n            "
    };
  }]);
})();
